import React from 'react';
import {
    GuestGuard,
} from '../guards/RolesGuard';
import Login from '../features/auth/login';
import Register from '../features/auth/register';
import ResetPassword from '../features/auth/reset-password';
import Layout from '../container/Layout';
import Intro from '../features/dashboard/intro/Intro';
import AiAuth from '../features/ai-auth/AiAuth';
import Homepage from '../features/dashboard/dashboards-options';
import ChatHistory from '../features/dashboard/history/ChatHistory';
import Chats from '../features/dashboard/chats/Chats';
import { UserGuard } from '../guards/UserGuard';
import Faqs from '../features/dashboard/faqs/Faqs';
// import WelcomePage from '../features/auth/welcome';

export interface RouteDefinition {
    path: string;
    element: JSX.Element;
    guard?: () => boolean;
    index?: string;
    key?: string;
    childrens?: RouteDefinition[];
}

export const routes: RouteDefinition[] = [
    // {
    //     path: '/',
    //     element: <WelcomePage />,
    //     key: 'guest',
    //     guard: GuestGuard,
    // },
	{
        path: '/register/:id',
        element: <AiAuth />,
        key: 'guest',
        guard: GuestGuard,
    },
	{
        path: '/westworld/register/:id',
        element: <AiAuth />,
        key: 'guest',
        guard: GuestGuard,
    },
	{
        path: '/auth',
        element: <AiAuth />,
        key: 'guest',
        guard: GuestGuard,
    },
    {
        path: '/login',
        element: <Login />,
        key: 'guest',
        guard: GuestGuard,
    },
    {
        path: '/apply',
        element: <Register />,
        key: 'guest',
        guard: GuestGuard,
    },
    {
        path: '/reset-password',
        element: <ResetPassword />,
        key: 'guest',
        guard: GuestGuard,
    },
 
    {
        path: '/',
        element: <Layout />,
        index: 'home',
        key: 'broker',
        guard: UserGuard,
        childrens: [
            {
                path: 'home',
                element: <Homepage/>
            },
			{
                path: 'history',
                element: <ChatHistory/>
            },
			{
                path: 'intro',
                element: <Intro/>
            },
			{
                path: 'chat/:id',
                element: <Chats />
            },
			{
				path: 'faqs',
				element: <Faqs />
			}
        ]
    },

];
